import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React, { Component } from 'react';
import * as logger from 'universal-logger';
import PropTypes from 'prop-types';
import hoistStatics from 'hoist-non-react-statics';
export var withSagas = function withSagas(config) {
  return function (WrappedComponent) {
    var DecoratedComponent =
    /*#__PURE__*/
    function (_Component) {
      _inherits(DecoratedComponent, _Component);

      function DecoratedComponent() {
        var _getPrototypeOf2;

        var _this;

        _classCallCheck(this, DecoratedComponent);

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DecoratedComponent)).call.apply(_getPrototypeOf2, [this].concat(args))); // Watch sagas should be initialized before we call on load

        _this.runSagas(config.watch, {
          dedupe: true
        });

        _this.runSagas(config.load);

        return _this;
      }

      _createClass(DecoratedComponent, [{
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.runSagas(config.cleanup);
        }
      }, {
        key: "runSagas",
        value: function runSagas(sagas) {
          var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
              _ref$dedupe = _ref.dedupe,
              dedupe = _ref$dedupe === void 0 ? false : _ref$dedupe;

          if (!sagas) {
            return;
          }

          var props = this.props,
              _this$context = this.context,
              store = _this$context.store,
              client = _this$context.client;
          var sagaRunner = dedupe ? store.runSaga : store.runSagaOnce;
          [].concat(sagas).filter(this.validateSaga).forEach(function (saga) {
            return sagaRunner(saga, client, props);
          });
        }
      }, {
        key: "validateSaga",
        value: function validateSaga(saga) {
          var isValid = typeof saga === 'function';

          if (!isValid) {
            var displayName = WrappedComponent.displayName || WrappedComponent.name || WrappedComponent;
            logger.warn("Invalid saga found in ".concat(displayName), saga);
          }

          return isValid;
        }
      }, {
        key: "render",
        value: function render() {
          return React.createElement(WrappedComponent, this.props);
        }
      }]);

      return DecoratedComponent;
    }(Component);

    DecoratedComponent.displayName = "withSagas(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
    DecoratedComponent.contextTypes = {
      client: PropTypes.object,
      store: PropTypes.object
    };
    DecoratedComponent.withSagas = config;
    return hoistStatics(DecoratedComponent, WrappedComponent);
  };
};